import { Injectable } from '@angular/core';

import { NgcContentOptions, NgcCookieConsentService } from 'ngx-cookieconsent';

import { TranslationService } from '@mirage-projects/cw-commons';

/**
 * This service manages some aspects of the cookies consent popup
 */
@Injectable({ providedIn: 'root' })
export class CookieConsentService {
    constructor(
        private ccService: NgcCookieConsentService,
        private translationService: TranslationService
    ) {}

    /**
     * Translate the intial resources for the cookie consent popupu to the current language
     */
    translate(): void {
        const content: NgcContentOptions = this.ccService.getConfig().content || {};

        content.allow = this.translationService.translate('COOKIES.ALLOW');
        content.deny = this.translationService.translate('COOKIES.DENY');
        content.message = this.translationService.translate('COOKIES.MESSAGE');
        content.link = this.translationService.translate('COOKIES.LINK_TEXT');

        this.restart();
    }

    /**
     * Initializes the cookie consent popup
     * This can be useful when the language has been updated, so the changes are reflected
     */
    restart(): void {
        this.ccService.destroy();
        this.ccService.init(this.ccService.getConfig());
        this.checkCookiesConsentVisibility();
    }

    /**
     * Logic to show or hide the cookies consent popup
     * It shows only if cookies are not previously consented or the url does not contains a
     * 'cookiesAccepted' param with a true value (this disables popup for some use cases)
     */
    checkCookiesConsentVisibility(): void {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const cookiesAcceptedParam = urlParams.get('cookiesAccepted');

        const areCookiesDisabledManually = cookiesAcceptedParam === 'true';
        const hasAnswered = this.ccService.hasAnswered();

        if (!areCookiesDisabledManually && !hasAnswered) {
            this.ccService.open();
        }
    }
}
